import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';

const i18nInstance = i18n.createInstance();

// Get language from localStorage user data or default to 'en'
const getUserLanguage = () => {
  try {
    const userData = localStorage.getItem('vetUser');
    if (userData) {
      const user = JSON.parse(userData);
      return user?.language || 'en';
    }
  } catch (error) {
    console.error('Error reading user language from localStorage:', error);
  }
  return 'en';
};

i18nInstance
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
    },
    lng: getUserLanguage(),
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
  });

// Listen for language changes when user data is updated
if (typeof window !== 'undefined') {
  // Update language when localStorage changes
  window.addEventListener('storage', (e) => {
    if (e.key === 'vetUser') {
      const newLanguage = getUserLanguage();
      if (newLanguage !== i18nInstance.language) {
        i18nInstance.changeLanguage(newLanguage);
      }
    }
  });
}

export default i18nInstance;


